(function () {
  "use strict";

  const SIDEBAR = "[data-collection-sidebar]";
  const LEFT = "[data-range-left]";
  const RIGHT = "[data-range-right]";
  const LINE = "[data-range-line]";
  const HOLDER = "[data-range-holder]";
  const ATTR_MIN = "data-se-min";
  const ATTR_MAX = "data-se-max";
  const ATTR_MIN_VAL = "data-se-min-value";
  const ATTR_MAX_VAL = "data-se-max-value";
  const ATTR_STEP = "data-se-step";
  const ATTR_UPDATE = "data-range-filter-update";
  const FIELD_MIN = "[data-field-price-min]";
  const FIELD_MAX = "[data-field-price-max]";
  const READY = "is-initialized";
  const TRACK_INSET = 7;

  if (customElements.get("range-slider")) return;

  customElements.define(
    "range-slider",
    class extends HTMLElement {
      constructor() {
        super();
        this.sidebar = this.closest(SIDEBAR);
        this.touchLeft = this.querySelector(LEFT);
        this.touchRight = this.querySelector(RIGHT);
        this.lineSpan = this.querySelector(LINE);
        this.min = parseFloat(this.getAttribute(ATTR_MIN));
        this.max = parseFloat(this.getAttribute(ATTR_MAX));
        this.step = 0;
        this.selectedTouch = null;
        this.startX = 0;

        this._onStart = (e) => this.onStart(e);
        this._onMove = (e) => this.onMove(e);
        this._onStop = (e) => this.onStop(e);
        this._onSidebarTransition = (e) => this.onSidebarTransitionEnd(e);
        this._onResize = () => {
          this.connectedCallback();
          if (this.sidebar) {
            this.sidebar.addEventListener(
              "transitionend",
              this._onSidebarTransition
            );
          }
        };

        document.addEventListener("theme:resize:width", this._onResize);
      }

      connectedCallback() {
        let minValue = this.min;
        if (this.hasAttribute(ATTR_MIN_VAL)) {
          minValue = parseFloat(this.getAttribute(ATTR_MIN_VAL));
        }
        let maxValue = this.max;
        if (this.hasAttribute(ATTR_MAX_VAL)) {
          maxValue = parseFloat(this.getAttribute(ATTR_MAX_VAL));
        }
        if (minValue < this.min) minValue = this.min;
        if (maxValue > this.max) maxValue = this.max;
        if (minValue > maxValue) minValue = maxValue;

        if (this.getAttribute(ATTR_STEP)) {
          this.step = Math.abs(parseFloat(this.getAttribute(ATTR_STEP)));
        }

        this.layout();
        this.setMinValue(minValue);
        this.setMaxValue(maxValue);
        this.paintLine();

        // Detach any previously bound start listeners before re-binding (safe
        // on re-init from resize / sidebar open).
        this.touchLeft.removeEventListener("mousedown", this._onStart);
        this.touchRight.removeEventListener("mousedown", this._onStart);
        this.touchLeft.removeEventListener("touchstart", this._onStart);
        this.touchRight.removeEventListener("touchstart", this._onStart);

        this.touchLeft.addEventListener("mousedown", this._onStart);
        this.touchRight.addEventListener("mousedown", this._onStart);
        this.touchLeft.addEventListener("touchstart", this._onStart, {
          passive: false,
        });
        this.touchRight.addEventListener("touchstart", this._onStart, {
          passive: false,
        });

        this.classList.add(READY);
      }

      layout() {
        this.trackWidth = this.offsetWidth;
        this.thumbWidth = this.touchLeft.offsetWidth || 14;
        this.maxX = Math.max(0, this.trackWidth - this.thumbWidth);
      }

      setMinValue(value) {
        if (this.maxX <= 0) return;
        const ratio = (value - this.min) / (this.max - this.min);
        const left = Math.max(
          0,
          Math.min(this.maxX, Math.round(ratio * this.maxX))
        );
        this.touchLeft.style.left = left + "px";
        this.setAttribute(ATTR_MIN_VAL, value);
      }

      setMaxValue(value) {
        if (this.maxX <= 0) return;
        const ratio = (value - this.min) / (this.max - this.min);
        const left = Math.max(
          0,
          Math.min(this.maxX, Math.round(ratio * this.maxX))
        );
        this.touchRight.style.left = left + "px";
        this.setAttribute(ATTR_MAX_VAL, value);
      }

      paintLine() {
        if (!this.lineSpan) return;
        const half = this.thumbWidth / 2;
        const start = Math.max(
          0,
          this.touchLeft.offsetLeft + half - TRACK_INSET
        );
        const width = Math.max(
          0,
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft
        );
        this.lineSpan.style.marginLeft = start + "px";
        this.lineSpan.style.width = width + "px";
      }

      onStart(e) {
        // Re-measure in case the layout changed (sidebar collapse/expand).
        this.layout();
        if (this.maxX <= 0) return;

        const point = e.touches ? e.touches[0] : e;
        this.selectedTouch = e.currentTarget;
        const initialLeft = this.selectedTouch.offsetLeft;
        this.startX = point.pageX - initialLeft;

        // Prevent native text selection during drag.
        document.body.style.userSelect = "none";
        document.body.style.webkitUserSelect = "none";

        document.addEventListener("mousemove", this._onMove);
        document.addEventListener("mouseup", this._onStop);
        document.addEventListener("touchmove", this._onMove, {
          passive: false,
        });
        document.addEventListener("touchend", this._onStop);
        document.addEventListener("touchcancel", this._onStop);

        if (e.cancelable) e.preventDefault();
      }

      onMove(e) {
        if (!this.selectedTouch) return;
        const point = e.touches ? e.touches[0] : e;

        // Block native text selection / page scroll while dragging.
        if (e.cancelable) e.preventDefault();

        let next = point.pageX - this.startX;

        if (this.selectedTouch === this.touchLeft) {
          const rightLimit = Math.max(
            0,
            this.touchRight.offsetLeft - this.thumbWidth
          );
          next = Math.max(0, Math.min(rightLimit, next));
        } else {
          const leftLimit = Math.min(
            this.maxX,
            this.touchLeft.offsetLeft + this.thumbWidth
          );
          next = Math.max(leftLimit, Math.min(this.maxX, next));
        }

        this.selectedTouch.style.left = next + "px";
        this.paintLine();
        this.calculateValue();

        const onChangeAttr = this.getAttribute("on-change");
        if (onChangeAttr) {
          new Function("min, max", onChangeAttr)(
            this.getAttribute(ATTR_MIN_VAL),
            this.getAttribute(ATTR_MAX_VAL)
          );
        }
        this.onChange(
          this.getAttribute(ATTR_MIN_VAL),
          this.getAttribute(ATTR_MAX_VAL)
        );
      }

      onStop() {
        document.removeEventListener("mousemove", this._onMove);
        document.removeEventListener("mouseup", this._onStop);
        document.removeEventListener("touchmove", this._onMove);
        document.removeEventListener("touchend", this._onStop);
        document.removeEventListener("touchcancel", this._onStop);

        document.body.style.userSelect = "";
        document.body.style.webkitUserSelect = "";

        this.selectedTouch = null;
        this.calculateValue();
        this.onChanged();
      }

      calculateValue() {
        if (this.maxX <= 0) return;
        const ratioLeft = this.touchLeft.offsetLeft / this.maxX;
        const ratioRight = this.touchRight.offsetLeft / this.maxX;
        let minVal = ratioLeft * (this.max - this.min) + this.min;
        let maxVal = ratioRight * (this.max - this.min) + this.min;

        if (this.step !== 0) {
          minVal = Math.floor(minVal / this.step) * this.step;
          maxVal = Math.floor(maxVal / this.step) * this.step;
        }

        if (this.selectedTouch === this.touchLeft) {
          this.setAttribute(ATTR_MIN_VAL, minVal);
        }
        if (this.selectedTouch === this.touchRight) {
          this.setAttribute(ATTR_MAX_VAL, maxVal);
        }
      }

      onChange(minVal, maxVal) {
        const holder = this.closest(HOLDER);
        if (!holder) return;
        const minField = holder.querySelector(FIELD_MIN);
        const maxField = holder.querySelector(FIELD_MAX);
        if (minField && maxField) {
          minField.value = minVal;
          maxField.value = maxVal;
        }
      }

      onChanged() {
        if (this.hasAttribute(ATTR_UPDATE)) {
          this.dispatchEvent(
            new CustomEvent("theme:range:update", { bubbles: true })
          );
        }
      }

      onSidebarTransitionEnd(e) {
        if (
          this.sidebar &&
          e.target === this.sidebar &&
          e.propertyName === "min-width"
        ) {
          this.sidebar.removeEventListener(
            "transitionend",
            this._onSidebarTransition
          );
          this.connectedCallback();
        }
      }

      disconnectedCallback() {
        if (this.sidebar) {
          this.sidebar.removeEventListener(
            "transitionend",
            this._onSidebarTransition
          );
        }
        document.removeEventListener("theme:resize:width", this._onResize);
        document.removeEventListener("mousemove", this._onMove);
        document.removeEventListener("mouseup", this._onStop);
        document.removeEventListener("touchmove", this._onMove);
        document.removeEventListener("touchend", this._onStop);
        document.removeEventListener("touchcancel", this._onStop);
        document.body.style.userSelect = "";
        document.body.style.webkitUserSelect = "";
      }
    }
  );
})();
